'use client'

// Single-use illustration: the SVG embeds fixed filter ids (filter*_10473_33546).
// SVGR does not auto-prefix ids, so do not render two instances on one page
// without unique-ifying them first.
import EmptyIllustration from '@/assets/icons/empty-files.svg'

import S from './LeaderboardEmptyState.module.scss'

export interface LeaderboardEmptyStateProps {
  title: string
  /** BAT-1110: the athletes board shows only the title («Nothing found»). */
  description?: string
  /** Optional CTA. Rendered only when both label and handler are provided. */
  actionLabel?: string
  onAction?: () => void
}

export function LeaderboardEmptyState({
  title,
  description,
  actionLabel,
  onAction
}: LeaderboardEmptyStateProps) {
  return (
    <div className={S.root}>
      <EmptyIllustration className={S.illustration} aria-hidden />
      <div className={S.text}>
        <h3 className={S.title}>{title}</h3>
        {description ? <p className={S.description}>{description}</p> : null}
      </div>
      {actionLabel && onAction ? (
        <button type="button" className={S.action} onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  )
}
